import React from 'react';
import { COLORS, FONTS } from '../shared/ContentData';

const ExitMessage = () => {
  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      color: 'rgba(255, 255, 255, 0.6)',
      fontFamily: FONTS.primary,
      fontSize: '14px',
      zIndex: 50,
    }}>
      Press ESC to leave
    </div>
  );
};

export default ExitMessage;